'use strict';

angular.module('adelementAdminApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('userAdvertiserMapping', {
                parent: 'entity',
                url: '/userAdvertiserMappings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.userAdvertiserMapping.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/userAdvertiserMapping/userAdvertiserMappings.html',
                        controller: 'UserAdvertiserMappingController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userAdvertiserMapping');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('userAdvertiserMapping.detail', {
                parent: 'entity',
                url: '/userAdvertiserMapping/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.userAdvertiserMapping.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/userAdvertiserMapping/userAdvertiserMapping-detail.html',
                        controller: 'UserAdvertiserMappingDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userAdvertiserMapping');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserAdvertiserMapping', function($stateParams, UserAdvertiserMapping) {
                        return UserAdvertiserMapping.get({id : $stateParams.id});
                    }]
                }
            })
            .state('userAdvertiserMapping.new', {
                parent: 'userAdvertiserMapping',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/userAdvertiserMapping/userAdvertiserMapping-dialog.html',
                        controller: 'UserAdvertiserMappingDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    userId: null,
                                    advertiserId: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('userAdvertiserMapping', null, { reload: true });
                    }, function() {
                        $state.go('userAdvertiserMapping');
                    })
                }]
            })
            .state('userAdvertiserMapping.edit', {
                parent: 'userAdvertiserMapping',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/userAdvertiserMapping/userAdvertiserMapping-dialog.html',
                        controller: 'UserAdvertiserMappingDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['UserAdvertiserMapping', function(UserAdvertiserMapping) {
                                return UserAdvertiserMapping.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('userAdvertiserMapping', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('userAdvertiserMapping.delete', {
                parent: 'userAdvertiserMapping',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/userAdvertiserMapping/userAdvertiserMapping-delete-dialog.html',
                        controller: 'UserAdvertiserMappingDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['UserAdvertiserMapping', function(UserAdvertiserMapping) {
                                return UserAdvertiserMapping.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('userAdvertiserMapping', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });
